import axiosInstance from '@/app/api/axiosInstance';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';
import { VoucherResponse, VoucherCreate, VoucherUpdate } from '@/app/types/voucher';

const API_URL = '/credit-notes'; // Specific endpoint for credit notes

export const listCreditNotes = async (params?: ListQueryParams): Promise<PaginatedResponse<VoucherResponse>> => {
  const response = await axiosInstance.get<PaginatedResponse<VoucherResponse>>(API_URL, { params });
  return response.data;
};

export const getCreditNote = async (id: number): Promise<VoucherResponse> => {
  const response = await axiosInstance.get<VoucherResponse>(`${API_URL}/${id}`);
  return response.data;
};

// Create credit note with specified data
export const createCreditNote = async (data: VoucherCreate): Promise<VoucherResponse> => {
  // Convert total_amount to string for backend Decimal field
  const payload = {
    ...data,
    total_amount: String(data.total_amount),
  };
  const response = await axiosInstance.post<VoucherResponse>(API_URL, payload);
  response.data.total_amount = parseFloat(String(response.data.total_amount));
  return response.data;
};

export const updateCreditNote = async (id: number, data: VoucherUpdate): Promise<VoucherResponse> => {
  // Convert total_amount to string for backend Decimal field
  const payload = {
    ...data,
    total_amount: data.total_amount ? String(data.total_amount) : undefined,
  };
  const response = await axiosInstance.patch<VoucherResponse>(`${API_URL}/${id}`, payload);
  response.data.total_amount = parseFloat(String(response.data.total_amount));
  return response.data;
};

export const deleteCreditNote = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${API_URL}/${id}`);
}; 